import { useQuery } from '@tanstack/react-query';
import { getChildDailyReportFromData } from '../../services/parentService';

export const useDailyReport = (childId: string | undefined, date?: string) => {
  const reportDate = date || new Date().toISOString().split('T')[0];

  return useQuery({
    queryKey: ['parent', 'daily-report', childId, reportDate],
    queryFn: () => getChildDailyReportFromData(childId!, reportDate),
    enabled: !!childId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useWeeklyReports = (childId: string | undefined) => {
  const today = new Date();
  const weekDates = Array.from({ length: 7 }, (_, i) => {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    return date.toISOString().split('T')[0];
  });

  const queries = weekDates.map(date => ({
    queryKey: ['parent', 'daily-report', childId, date],
    queryFn: () => getChildDailyReportFromData(childId!, date),
    enabled: !!childId,
    staleTime: 5 * 60 * 1000,
  }));

  // Use multiple queries for the week
  const results = queries.map(query => useQuery(query));

  const isLoading = results.some(result => result.isLoading);
  const hasError = results.some(result => result.error);
  const reports = results
    .map((result, index) => ({
      date: weekDates[index],
      report: result.data,
    }))
    .filter(item => item.report);

  return {
    reports,
    isLoading,
    hasError,
  };
};
